<template>
  <div
      v-if="!loading"
      :key="viewmode">
    <el-row>

      <el-col :md="24">
        <s-form-actions
            hxpadding="25px"
            v-if="viewmode=='filebookings'">
          <el-button icon="el-icon-circle-close" plain style="float: left"
                     v-if="$route.params.fileid&&$route.params.fileid!='all'"
                     @click='routeGo({name: "fileBookings",params: {fileid:null}});'
                     slot="left">
            <el-tag>{{ $route.params.fileid }}</el-tag>
            {{ fileName }}
          </el-button>
          <div slot="middle" style="padding: 5px">
            <el-switch v-model="groupCtx" active-text="Booking" active-value="booking"
                       inactive-value="place"
                       inactive-text="Places"></el-switch>
          </div>
          <template
              v-if="$userProfile.settings?.HandleEmails=='1'&&(!$route.params.fileid||$route.params.fileid=='all')">

            <q-btn
                style="margin-left: 4%"
                slot="middle"
                @click="displayOnlyBounced=!displayOnlyBounced;"
                title="View all bounced emails"

                :color="displayOnlyBounced?'green':null"
            >

              <span class="normal material-icons" title="no-email / in-que">unsubscribe</span>
              <fa icon="eye"></fa>


            </q-btn>
            <sf-button
                confirm="Shall I sent again all bounced emails?"
                @click="send_emails(true,true)"
                title="Sent again all bounced emails"
                type="success">
              <span class="normal material-icons" title="no-email / in-que">unsubscribe</span>
              <fa icon="bolt"></fa>
            </sf-button>
          </template>
          <template v-if="$route.params.fileid&&$route.params.fileid!='all'">
            <sf-button
                type="info"
                @click="displayPivoter=!displayPivoter">
              <i class="material-icons">info</i></sf-button>
            <sf-button
                type="primary"
                style="float: left;"
                @click="goAutoRoute" v-if="$userProfile.settings?.UseAutoRoute=='1'">
            <span><i
                title="Produce routes"
                class="material-icons">airport_shuttle</i> <i class="material-icons">done_all</i></span>
            </sf-button>
            <sf-button
                type="danger"
                style="float: left;"
                :confirm="getStoreValues('selectedBookings')&&getStoreValues('selectedBookings').length?'Are you sure you want to delete '+getStoreValues('selectedBookings').length+' bookings?':'Are you sure ? this action will delete !!!ALL!!! the imported bookings regarding this import'"
                @click="removeBookings()">
              <i class="material-icons">delete_sweep</i>{{
                getStoreValues('selectedBookings') && getStoreValues('selectedBookings').length ? getStoreValues('selectedBookings').length : ''
              }}
            </sf-button>
            <template v-if="$userProfile.settings?.HandleEmails=='1'">

              <sf-button material="cloud_download" @click="downloadExcel" v-if="this.$route.params.fileid"></sf-button>
              <sf-button

                  @click="send_emails(true)"
                  title="Sent all the emails again no matter what"
                  type="primary">
                <fa icon="paper-plane"></fa>
                <fa icon="hammer"></fa>
                <el-tag type="primary" v-if="getStoreValues('selectedBookings')?.length">
                  {{ getStoreValues('selectedBookings').length }}
                </el-tag>

              </sf-button>
              <sf-button

                  @click="get_email_report(true)"
                  title="Find out what happened with the emails"
                  type="warning">
                <fa icon="mail-bulk"></fa>
              </sf-button>

              <sf-button

                  @click="send_emails()"
                  title="Sent the emails that have not be send"
                  type="success">
                <fa icon="paper-plane"></fa>
              </sf-button>
            </template>
          </template>
        </s-form-actions>
      </el-col>
    </el-row>
    <el-row v-loading="fetchingData">
      <tree-reporter v-if="displayPivoter" lara-processor="bookings" :r-query="bookingsQuery"
                     :colDefinitions="colBookingDefinitions"
                     :display-data="true"
                     :pivot-cols="['tripDateTime','tripTitle','loc_code','ppid']"
                     :aggr-cols="['pax','adults','children']"></tree-reporter>
      <s-table
          v-else
          :selectStorage="($route.params.fileid&&$route.params.fileid!='all')||viewmode!='filebookings'?'selectedBookings':null"
          :key="clock+(needsPagination?1:0)"
          :colDefinitions="colBookingDefinitions"
          lara-processor="bookings"
          :r-query="bookingsQuery"
          :cellSelectionWithObjects="true"
          @cell-clicked="goToBooking"
          @data-loaded="checkFile"
          ref="bookingList"
          :pagging="needsPagination?100:2000"
          :lazy-loader="needsPagination"
          :rowClassFactory="bookingStyler"
          @select="keepSelected"
          :selectionId="$route.params.bookingid"
          @cell-change="handleBooking"
      />
    </el-row>
    <el-drawer
        :modal-append-to-body="false"
        :size="rightDrawerSize()"
        :visible.sync="showRightModal"
        direction="rtl"
        :before-close="goBackToTrips"
        :show-close="false"
        destroy-on-close
        :withHeader="false"
        :wrapperClosable="false">
      <router-view
          v-if="showRightModal"
          @done="goBackToTrips()"
          @delete="(e)=>$refs.bookingList?$refs.bookingList.removeRow(e):null"
          @input="updateTable"></router-view>
    </el-drawer>

    <s-modal
        title="Location resolver"
        v-model="pupResolverDialog"
        position="bottom"
        transition-show="fade"
    >

      <s-pupresolver
          v-if="processPup"
          :forFileId="$route.params.fileid"
          :pupInfo="processPup"
          @done="$refs.bookingList.reload();pupResolverDialog=false"></s-pupresolver>

    </s-modal>
    <s-modal
        title="Email report"
        v-model="emailDialog"
        append-to-body
        :width="'90%'"
        destroy-on-close>
      <s-email-report
          v-if="emailDialog"
          @done-processing="++clock"
          :emailData="emailReport">

      </s-email-report>
    </s-modal>
    <!-- <booking-form v-model="editBookingData"></booking-form> -->
  </div>
</template>
<script>
import * as api from "~/api/resource";
import axiosLocal from "axios";
import {mapGetters, mapActions, mapMutations} from "vuex";
import {async} from "q";
import SqTable from "../../Form/SqTable";
import {getModxProcessor} from "../../../api/resource";
import {apiGetCall, apiPostCall} from "../../../api/laravel";

const goToRoutes = (res) => {
  window.open(
      "v-route-handling.html?selectedRoutes=" + res.join(","),
      "_blank"
  );
}
let _email_token = null
export default {
  components: {SqTable},
  props: {
    viewmode: {type: String, default: null},
  },
  async created() {

    if (!this.lockedOnPath)
      this.lockedOnPath =
          this.$route.name == "tripBookingsBooking"
              ? "tripBookings"
              : this.$route.name;
    // const vm = this;
    // _log_("LOCK on.. ", this.lockedOnPath);
    // if (!this.rooms.length) await this.fetchRooms();
    // const bkid = this.$route.query ? this.$route.query.bkid : null;
    // if (bkid) {
    //   var { data } = await api.fetchProcessor(
    //     "bookings/vuebooking",
    //     this.$route.query
    //   );
    //   this.booking = data.results;
    // }
    // await this.fetchAvailableBookingTags();
    this.loading = false;
  },
  watch: {
    "$route.params.bookingid": {
      async handler(bkid, oldval) {
        _log_("get b oo ", this.lockedOnPath, this.$route.name);
        if (!this.lockedOnPath)
          this.lockedOnPath =
              this.$route.name == "tripBookingsBooking"
                  ? "tripBookings"
                  : this.$route.name;
        if (this.$route.name.indexOf(this.lockedOnPath) < 0) return;
        _log_("get b oo 2 ", bkid, oldval);
        if (bkid && bkid != oldval) {
          this.showRightModal = true;
          // this.loading = true;
          // var { data } = await api.fetchProcessor(
          //   "bookings/vuebooking",
          //   this.$route.query
          // );
          // this.booking = data.results;
          // this.loading = false;
        }
        _log_("get b oo 4 ", bkid, oldval);
        if (!bkid) this.showRightModal = false;
      },
      immediate: true,
    },
    // "$route.query.display_file_info": {
    //   async handler(display_file_info) {
    //     _log_("get b oo $route.params.display_file_info", display_file_info);
    //     if (display_file_info) {
    //       this.loadFileInfo()
    //       this.$router.replace({query: {display_file_info: null}})
    //     }
    //   },
    //   immediate: true,
    // },
    // "$route.params.fileid": {
    //   async handler(fileid, oldval) {
    //     _log_("get b oo $route.params.fileid", this.userDomain, fileid, oldval);
    //     if (this.userDomain == 'fidelity' && fileid && fileid != oldval) {
    //       this.get_email_report();
    //     }
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    ...mapMutations({
      setStore: "helpers/setStore",
      toggleSelection: "helpers/toggleSelection",
    }),
    checkFile({results}) {
      // _log_('checkFile', results)
      this.fileType = results?.[0]?.tripType || 'ACOM'
      this.fileName = results?.[0]?.file?.subject || results?.[0]?.file?.name
    },
    async goAutoRoute() {
      const vm = this;
      //  @click="pipeActions(['=>route/autocomposer','->goToRutes'],{file_id:selected_file,file_ids:selected_files});"
      const {data: checkRoutes} = await api.fetchProcessor(
          "route/autocomposer",
          {
            file_id: this.$route.params.fileid,
            checkRutes: true,
          })
      if (checkRoutes.results?.length) {
        this.$confirm('A lot of these bookings have already been routed. If you proceed you may loose any changes you have made', 'You should know!', {
          confirmButtonText: 'I want to rebuild the routes',
          cancelButtonText: 'Let me see the routes',
          type: 'warning'
        })
            .then(async () => {
              const {data} = await api.fetchProcessor(
                  "route/autocomposer",
                  {
                    file_id: this.$route.params.fileid
                  })
              // _log_('data autocomposer', data.results)
              if (!data?.results?.routenames?.length)
                vm.$message.error('something went wrong')
              else
                goToRoutes(data.results.routenames)
            })
            .catch(() => {
              goToRoutes(checkRoutes.results)
            });

      } else {
        const {data} = await api.fetchProcessor(
            "route/autocomposer",
            {
              file_id: this.$route.params.fileid
            })
        // _log_('data autocomposer', data.results)
        if (!data?.results?.routenames?.length)
          vm.$message.error('something went wrong')
        else
          goToRoutes(data.results.routenames)
      }

    },
    // async loadFileInfo() {
    //   //pipeActions(['=>reservations/files/get>=fileInfo','=>reservations/getlist>=processLog','->swichModals'],{info:1,objectId:selected_file,file:selected_file});
    //   const {data} = await api.fetchProcessor("reservations/files/get", {
    //     info: 1,
    //     objectId: this.$route.params.fileid,
    //     file: this.$route.params.fileid
    //   });
    //   this.fileInfo = data.object
    //   this.processLog = await api.getModxList("reservations", {
    //     info: 1,
    //     objectId: this.$route.params.fileid,
    //     file: this.$route.params.fileid
    //   });
    //   this.infoDialog = true
    //   _log_('loadFileInfo', data)
    // },
    changeFileCompany(coid) {
      var vm = this;
      this.$confirm(
          "This will change the Tour company releated to these bookings. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
      )
          .then(() => {
            chainedAjax(
                "reservations/files/updateall",
                {file_id: this.selected_file, companyid: coid},
                function (res) {
                  if (res)
                    vm.$message({
                      type: "success",
                      message: "Ok Done",
                    });
                }
            );
          });
    },
    async handleBooking(e) {
      //process before edit

      const data = await api.updateProcessor("vue_booking/update", e.row);
      this.$refs.bookingList.reloadRow(e.row.id);
    },
    keepSelected(sels) {
      const vm = this;
      _log_("keepSelected sent data reseved.....", sels);

      // this.setStore({
      //   storename: "selectedBookings",
      //   data: sels,
      // });

      //       let sentPackg={bkids: '13,38',
      // tripid: 9,
      // do: 'changeTrip',

      // action: booking/fullupdate}
    },
    downloadExcel() {

      this.$message('please wait file is downloading')
      api.ajax_download("vue_booking/getlist", {
        file_id: this.$route.params.fileid,
        download: 'sunweb-fidelity'
      });

    },
    async removeBookings() {
      _log_(' this.getStoreValues("selectedBookings");', this.getStoreValues("selectedBookings"))
      if (this.getStoreValues("selectedBookings") && this.getStoreValues("selectedBookings").length) {
        const data = await api.getModxProcessor("vue_booking/fullupdate", {
          do: 'deleteBookings',
          bkids: this.getStoreValues("selectedBookings")
              .map(bk => bk.id)
        });
        this.$alert('Done deleting')
        this.setStore({storename: 'selectedBookings', data: null})
        ++this.clock
      } else if (this.viewmode == "filebookings") {
        const data = await api.removeObject("reservations/files/", {
          objectId: this.$route.params.fileid,
          file_id: this.$route.params.fileid,
        });
        this.$emit("delete", data);
        this.routeGo({name: "filemanager"});
      }
      //pipeActions(['->confirmAction','=>reservations/files/remove','->reloadFileList'],{objectId:selected_file,file_id:selected_file});selected_file=null
    },
    bookingStyler(row) {
      if (this.$userProfile.settings?.HandleEmails == '1') {
        if (row.row.successLevel > 20 && row.row.successLevel < 80) return "warning"
        if (row.row.successLevel < 81) return "danger"
      } else if (row.row.successStatus == 'no-info') return "warning"
      return null
      // _log_("bookingStyler??", row);
      // return !row.row.ppid || !row.row.customer_id ? "danger" : null;
    },
    async send_emails(force, onlyBounced) {
      // const _token = await this.getApiAuthToken()
      // const apiAxios = axiosLocal.create(),
      const vm = this;
      if (onlyBounced) {
        //onlyBounced ? "bookings/notify" :
        let data = await apiPostCall("bookings/notify", force ? {
          force: force,
          fileid: this.$route.params.fileid
        } : null)
        return
      }
      let forceMessage = force ? (this.getStoreValues('selectedBookings')?.length ? this.getStoreValues('selectedBookings')?.length + '...EMAILS even they have been sent already' : '...ALL THE EMAILS even the ones that have been sent') : ' the emails that have not been send yet';
      this.$confirm("Are you sure you want to email " + forceMessage + "?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
          .then(async () => {
            let data = await apiPostCall("email/" + this.$route.params.fileid, force ? {
              force: true,
              places: this.getStoreValues('selectedBookings')?.map(em => em.ppid)
            } : null)//this.emailCall("email/" + this.$route.params.fileid + (force ? '?force=true' : ''), 'POST')
            // _log_('data', data)
            let dt = data?.data || data,
                msg = "",
                emailsSent = 0,
                allreadySent = 0;
            for (var im in dt) {
              if (!dt[im] || dt[im] == "") ++allreadySent;
              else ++emailsSent;
            }
            msg =
                emailsSent +
                " emails were send and " +
                allreadySent +
                " emails had been sent in the past";
            this.$message({
              type: "success",
              message: msg,
            });
            ++this.clock
          })
          .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: 'Delete canceled'
            // });
          });

      return false;
    },
    goBackToTrips() {
      if (this.$route.params.tripid)
        this.$router.push({
          name: "tripBookings",
          params: {tripid: this.$route.params.tripid},
          query: this.$route.query,
        });
      if (this.$route.params.fileid)
        this.$router.push({
          name: "fileBookings",
          query: this.$route.query,
          params: {fileid: this.$route.params.fileid},
        });
      this.showRightModal = false
    },
    async updateEmailStatus(emailId) {
      const responseHook = await apiGetCall("email/" + emailId) //this.emailCall("email/" + emailId)
      // if (!_email_token) {
      //   _email_token = await this.getApiAuthToken()
      // }
      // let responseHook = await fetch(
      //     "https://api.safecontrol.gr/api/email/" +
      //     emailId,
      //     {
      //       headers: {
      //         "Content-Type": "application/json;charset=utf-8",
      //         Authorization: Api.token_type + " " + _email_token,
      //       },
      //     }
      // );
      return responseHook
    },
    async get_email_report(refreshMailJet) {

      // _log_("API.0..get_email_report..", this.emailReports)
      await apiGetCall("file_report/" + this.$route.params.fileid)
      // await apiGetCall("bookings", {file_id: this.$route.params.fileid})
      return
      if (refreshMailJet && this.emailReports) {
        // this.fetchingData = true
        for (let iMail = 0; iMail < this.emailReports.length; iMail++) {

          const emailReports = this.emailReports[iMail].emails;
          _log_("--API.2..get_email_report..", emailReports);
          if (emailReports && emailReports.length)
            for (let iEmailReport = 0; iEmailReport < emailReports.length; iEmailReport++) { // {
              const emailReport = emailReports[iEmailReport]
              _log_("----API.3..get_email_report..", emailReport, emailReport.uuid);
              if (emailReport.uuid) {
                this.$message('check email ' + emailReport.to + ' ,' + (iMail + 1) + ' from ' + this.emailReports.length)
                const data = await this.updateEmailStatus(emailReport.id)
                _log_("=API.l..get_email_report..", data);
              }
            }
          // }

        }
        refreshMailJet = false
        // this.fetchingData = false

        // ++this.clock;
        // return
      }
      // const {data} = await api.fetchProcessor('vue_booking/getlist', this.bookingsQuery);
      // _log_("RE.._token..", data.results);

      //old way
      this.emailReports = null;
      this.fetchingData = true
      // const _token = await this.getApiAuthToken()

      // if (_token === false) {
      //   this.fetchingData = false
      //   this.$message.error("There is a security problem...,Please logout and login.");
      // }

      try {

        if (refreshMailJet) {
          await apiGetCall("file/" + this.$route.params.fileid)
          // await this.emailCall("file/" + this.$route.params.fileid)


        }
        this.emailReports = await await apiGetCall("bookings", {file_id: this.$route.params.fileid})//this.emailCall("bookings?file_id=" + this.$route.params.fileid)

        //
        // let response = await fetch(
        //     "https://api.safecontrol.gr/api/bookings?file_id=" +
        //     this.$route.params.fileid,
        //     {
        //       headers: {
        //         "Content-Type": "application/json;charset=utf-8",
        //         Authorization: Api.token_type + " " + _token,
        //       },
        //     }
        // );
        // this.emailReports = await response.json();
      } catch (error) {
        this.$message.error("There was a problem getting email reports.");
      }
      this.fetchingData = false

      ++this.clock;
      return false;
    },


    updateTable(e) {
      _log_("updateTable,", e);
      if (e) {
        _log_("rel333334oad,", e);
        this.$refs.bookingList.reloadRowOrAppend(e);
      }
    },
    handleBookingUpdate(e) {
      // this.$router.go(-1);
      _log_("updateTable reload,", e);
      if (e) {
        _log_("rel333334oad,", e);
        this.$refs.bookingList.reloadRowOrAppend(e);
      }
      this.goBackToTrips();
      // this.showRightModal = false;

      // if(this.$route.params.fileid)
      // this.routeGo({
      //   name: "fileBookings",
      //   params: { fileid: this.$route.params.fileid }
      // });
      //  if(this.$route.params.fileid)
      // this.routeGo({
      //   name: "fileBookings",
      //   params: { fileid: this.$route.params.fileid }
      // });
    },
    goToBooking(val) {
      const vm = this;
      _log_("hell yes goToBooking", val);
      if (
          this.workingTripType != "EXCRS" &&
          !val.row.ppid &&
          val.column.property == "ppid"
          //  &&
          // val.row.possible_pp
      ) {
        this.processPup = val.row.possible_pp;
        this.$nextTick(() => this.pupResolverDialog = true)

        return;
      }
      //email_ppid
      if (val.column.property == "successLevel") {

        if (
            (this.emailReport = val.row.emails)
        ) {
          this.$set(this.emailReport, 'bookings', val.row.bookings)
          this.emailDialog = true;
        }
        return;
      }
      if (val.column.property == "file") {
        vm.routeGo({
          name: "fileBookings",
          params: {fileid: val.row.file.id, limit: 0},
        });
        return;
      }
      if (val.row.history && val.column.property == "history") {
        const item = val.row;
        if (item.history) {
          var fstate = "moved to",
              gotof = null;
          if (item.history.is_in_file) gotof = item.history.is_in_file;
          else {
            if (fstate = "was in") gotof = item.history.was_in_file;
          }
          this.$notify({
            type: "warning",
            title: "Booking " + fstate + " another file.",
            onClick(e) {
              vm.routeGo({
                name: "fileBookings",
                params: {fileid: gotof, limit: 0, sort: "ppid"},
              });

              vm.close();
            },
            duration: 3000,

            message: "Click here to go to the file",
          });
        }
        return;
      }
      if (this.viewmode == "filebookings" && val.column.property != "reference") return;
      _log_("suggest..", val.column.property);
      let Q = this.$route.query;
      Q.bookingid = val.row.id;
      // _log_("hell yes", this.$route);
      const ctxRt = this.$route.name;
      this.routeGo({
        name: ctxRt + "Booking",
        params: Q,
      });
    },
    async queryBookingTypes(queryString, cb) {
      var {data} = await api.fetchProcessor("gears/gettags", {
        type: "Booking_bookingType",
      });
      var res = [];
      if (data.results)
        data.results.forEach((element) => {
          if (element.toLowerCase()
              .indexOf(queryString.toLowerCase()) >= 0)
            res.push({value: element});
        });
      // _log_("suggest..", data);
      cb(res);
    },
    async saveBooking() {
      await api.updateJsonProcessor("bookings/mixedupdate", this.booking);
      this.goBookings();
    },
    // ...mapActions({
    //   fetchRooms: "hotelinfo/fetchRooms",
    //   fetchAvailableBookingTags: "hotelinfo/fetchAvailableBookingTags",
    // }),
    async refreshAvailability(roomid, range) {
      var {data} = await api.fetchProcessor("gears/vueavailability", {
        forIdRooms: roomid,
        "bookrange[]": range,
      });
      this.bookedDates = data.results.rooms;
    },
    isBookable(calDate) {
      const unxCalDate = Math.floor(calDate.getTime() / 1000);
      for (let index = 0; index < this.bookedDates.length; index++) {
        const bkr = this.bookedDates[index];
        if (bkr.arrivalDate <= calDate && bkr.departureDate >= calDate) {
          _log_("??NO?" + calDate, this.bookedDates);
          return true;
        }
      }
      return false;
    },
    ...mapMutations({
      setStore: "helpers/setStore",
    }),
  },
  data() {
    return {
      displayOnlyBounced: false,
      displayPivoter: false,
      infoActiveTab: 'importsSums',
      processLog: null,
      fileInfo: null,
      fileName: null,
      fileType: null,
      infoDialog: false,
      emailReport: null,
      emailDialog: false,
      clock: 0,
      fetchingData: false,
      lockedOnPath: null,
      loading: true,
      selectedBookings: null,
      errors: {},
      pupResolverDialog: false,
      processPup: null,
      showRightModal: false,
      bookedDates: [],
      working_co_id: null,
      emailReports: null,
      editBookingData: null,
      bookings: REPO.bookings,
      userProfile: UserProfile,
    };
  },
  computed: {
    ...mapGetters({
      getStore: "helpers/getStore",
      getStoreValues: "helpers/getStoreValues",
    }),
    needsPagination() {// this.$route.params.fileid
      return !((this.$route.params.tripid && this.$route.params.tripid != 'all') || (this.$route.params.fileid && this.$route.params.fileid != 'all'))
    },
    modalTitle() {
      return "details";
    },
    workingTripType() {
      return this.$route.params && this.$route.params.kind
          ? this.$route.params.kind.toUpperCase()
          : null// (this.viewmode=='filebookings'?'IMPORTED':null);//check this out
    },
    groupCtx: {
      set(v) {
        _log_("go ahead/bookingRange/", v);
        // if (this.loading) return;s
        let q = JSON.parse(JSON.stringify(this.$route.query));
        q.groupCtx = v
        this.routeGo(
            {
              query: q,
            },
            true
        );

        return;
      },
      get() {
        _log_("go ahead/bookingRange/", this.$route.query);
        let o = [];
        if (!this.$route.query.groupCtx || this.$route.query.groupCtx == 'booking') {
          return 'booking'
        } else return 'place'


      },
    },
    bookingsQuery() {
      // var q = { ...this.$route.params, type: "full" }
      let q = {type: "full"};
      if (this.$route.params.fileid && this.$route.params.fileid != "all")
        q.fileid = this.$route.params.fileid;
      if (this.$route.params.tripid && this.$route.params.tripid != "all")
        q.tripid = this.$route.params.tripid;
      if (this.$route.params.fileid && this.$route.params.fileid != "all")
        q.fileid = this.$route.params.fileid;
      if (this.bookingRange) q.range = this.bookingRange;
      if (this.workingTripType) q.tripTypes = this.workingTripType;
      if (this.$route.query.query) {
        q.searching = true
        q.customerSearch = this.$route.query.query;
      }
      if (this.$route.query.ppid)
        q.ppid = this.$route.query.ppid;
      if (this.$route.query.coid)
        q.coid = this.$route.query.coid;
      if (this.$route.query.invoice_status)
        q.invoice_status = this.$route.query.invoice_status;
      if (this.$route.query.booking_status)
        q.bookingStatus = this.$route.query.booking_status;
      if (this.$route.query.tourcoselect)
        q.tourcoselect = this.$route.query.tourcoselect;
      q.transferTypes = "all";
      q.groupCtx = this.groupCtx
      q.type = "full";
      q.distributors = this.$route.query.distributor_select;
      if (!this.$route.query.bookings_sort) {

        if (this.$userProfile.settings?.HandleEmails == '1') {
          q.dir = 'ASC'
          q.sort = 'successLevel'
        } else {
          q.dir = 'DESC'
          q.sort = 'id'
        }
      }
      q.displayOnlyBounced = this.displayOnlyBounced
      return q;
    },
    colBookingDefinitions() {
      //
      let vm = this;
      let rw = "580px";
      const succesStatusIcons = {
            ready: 'pending',
            success: 'hourglass_top',
            deferred: 'hourglass_empty',
            processed: 'forward_to_inbox',
            delivered: 'mark_email_read',
            open: 'drafts',
            'no-info': 'no_accounts',
            'no-email': 'unsubscribe',
            'in-que': 'schedule_send',
            'sending': 'schedule_send',
          },
          badStatus = 'sentiment_very_dissatisfied'
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      const kindOfTrips = vm.$route.params.kind ? vm.$route.params.kind.toLowerCase() : 'other';
      let currentViewMode = kindOfTrips == "excrs" ? 'excrs' : (this.viewmode ? this.viewmode : 'other'),
          extraConstrain = (!this.$route.params.tripid || this.$route.params.tripid == "all") ? 'showtrip' : null
      if (currentViewMode == 'other' && (kindOfTrips.indexOf('arv') >= 0 || kindOfTrips.indexOf('dep') >= 0)) currentViewMode = 'transfers'
      currentViewMode = this.$route.query.groupCtx == 'place' ? 'places' : currentViewMode
      _log_("bookings... this.$route.query.groupCtx q ", vm.$userProfile.settings);
      let cols = [
        {
          viewnModes: ['filebookings'],
          prop: "history",
          width: "70px;",
          label: '<i class="material-icons">change_history</i>',
          action: "button",
          buttonType: "default",

          disableClick(row) {
            return !row.history;
          },
          formatter: function (val, cols, row) {
            // _log_(">>history>>", val, row);
            if (!val) return;
            if (val.was_in_file)
              return '<i class="material-icons" title="this is an update" style="color:red">subdirectory_arrow_right</i>'; //  '<i class="fas fa-file-import"></i>'
            // _log_(">>>>" + val, row);
            return '<i class="material-icons" title="this has been updated from another file" >subdirectory_arrow_left</i>'; //'<i class="fas fa-file-export"></i>';
          },
        },
        {
          viewnModes: ['filebookings' + (vm.$userProfile.settings?.HandleEmails == '1' ? 'disabled' : '')],
          prop: "notes",
          width: "50px;",
          label: '<i class="material-icons">schedule</i>',


          formatter: function (val, cols, row) {
            // _log_(">>history>>", val, row);
            if (!val) return;
            let out = '';
            if (val?._warnings)
              out += ' <span title="' + Object.values(val._warnings).join('.') + '" class="label label-danger"><i class="material-icons">schedule</i></span>';
            else out += ' <span  class="label label-info"><i class="material-icons">schedule</i></span>';
            return out;
          },
        },
        {
          viewnModes: ['excrs' + (vm.$userProfile.settings.aade_key ? '' : '_disabled'),
            'transfers' + (vm.$userProfile.settings.aade_key ? '' : '_disabled')],
          prop: "inv_aa",
          width: "60px",
          label: "Inv.",
          alterClickable: true,
          link(val, colDefs, row, vm) {
            // _log_(">possiblalterClickablee_pp>>>" + val, row);
            if (!row.inv_timologioId) return "";
            // _log_(">poss!!!!!iblalterClickablee_pp>>>" + val, row);
            const url = (vm.$route.params.kind == "excrs") ? "/" +
                Travel.wdb.replace("_", "-") +
                "voucher-printer-excrs.html?bkid=" +
                row.id
                :
                "/" +
                Travel.wdb.replace("_", "-") +
                "voucher-printer-transfers.html?bkid=" +
                row.inv_timologioId;
            return url;
          },
          formatter: function (val, cols, row) {
            // _log_(">possiblalterClickablee_pp>>>" + row.refunt_inv_aa, row);
            let out = "<div class='status-cell'>";
            if (row.inv_aa) {
              if (row.inv_aade_uid == 'error')
                out +=
                    '<span title="PROBLEM WITH TAX OFFICE ' +
                    row.inv_timo_group +
                    ":" +
                    row.inv_kind +
                    '" class="label label-danger ">' +
                    row.inv_aa +
                    "</span>";
              else
                out +=
                    '<span title="invoiced ' +
                    row.inv_timo_group +
                    ":" +
                    row.inv_kind +
                    '" class="label label-success ">' +
                    row.inv_aa +
                    "</span>";
            }


            out += "</div>";

            return out;
          },
        },
        {
          viewnModes: ['excrs' + (vm.$userProfile.settings.aade_key ? '' : '_disabled')],
          prop: "refunt_inv_aa",
          width: "60px",
          label: "R/ND",
          alterClickable: true,
          link(val, colDefs, row, vm) {
            // _log_(">possiblalterClickablee_pp>>>" + val, row);
            if (!row.inv_timologioId) return "";
            // _log_(">poss!!!!!iblalterClickablee_pp>>>" + val, row);
            const url =
                Travel.wdb.replace("_", "-") +
                "refund-invoice-printer.html?bkid=" +
                row.refunt_inv_timologioId;
            return url;
          },
          formatter: function (val, cols, row) {
            if (!val) return
            // _log_(">possiblalterClickablee_pp>>>" + row.refunt_inv_aa, row);
            let out = "<div class='status-cell'>";
            out += '<span title="refunt invoice from invoice num' +

                '" class="label  label-invoice ">' +
                row.refunt_inv_aa +
                "</span>";


            out += "</div>";

            return out;
          },
        },
        {
          viewnModes: ['transfers' + (vm.userDomain == 'travel2' ? '' : '_disabled')],
          prop: "note_sunweb_report", minWidth: "50px", label: "SUNWEB",
          formatter: function (val, cols, row) {
            if (!val) return '<i title="not reported  yet" class="el-icon-phone"></i>'
            if (val == 'success') return '<i  title="successfully reported" class="el-icon-phone-outline"></i>'
            return '<i  title="' + val + '" style="color: #ff9393" class="el-icon-warning"></i>'
          }
        },
        {
          viewnModes: ['excrs'],
          prop: "status",
          width: "160px",
          label: "Status",
          alterClickable: true,
          link(val, colDefs, row, vm) {
            // _log_(">possiblalterClickablee_pp>>>" + val, row);
            if (!row.inv_timologioId) return "";
            // _log_(">poss!!!!!iblalterClickablee_pp>>>" + val, row);
            const url =
                "/" +
                Travel.wdb.replace("_", "-") +
                "voucher-printer-transfers.html?bkid=" +
                row.inv_timologioId;
            return url;
          },
          formatter: function (val, cols, row) {
            // _log_(">possiblalterClickablee_pp>>>", val, row);//
            let out = "<div class='status-cell'>";

            out += !row.routeNum ? '<span title="booking not scheduled for transfer (' + row.meantype + ')" class="label label-warning"><i class="material-icons">directions_bus</i></span>'
                : ' <span title="booking has been scheduled  for transfer ' + row.meantype + '" class="label label-primary"><i class="material-icons">directions_bus</i></span>';
            if (kindOfTrips == "excrs") {

              out +=
                  val == "normal"
                      ? '<span title="booking is valide" class="label label-primary"><i class="material-icons">show_chart</i></span>'
                      : ' <span title="booking is overbooked" class="label label-warning"><i class="material-icons">multiline_chart</i></span>';
              out +=
                  row.execStatus == "normal"
                      ? '<span title="booking is on schedule" class="label label-primary"><i class="material-icons">flash_on</i></span>'
                      : ' <span title="booking is not scheduled by us" class="label label-warning"><i class="material-icons">block</i></span>';
              let clsP =
                  row.invoiceinfo == 'block_api' ? "label-danger" : "label-primary";
              let clsL = row.locked ? "label-danger" : "label-primary";

              out +=
                  '<span title="booking locked" class="label ' +
                  clsL +
                  '"><i class="material-icons">vpn_key</i></span>';
              out +=
                  '<span title="' + (row.invoiceinfo == 'block_api' ? 'no api will be issued' : 'api will be issued') + '" class="label ' +
                  clsP +
                  '"><span class="material-icons">' +
                  'receipt' +
                  '</span></span>';
            } else {
              out +=
                  row.status.toLowerCase()
                      .indexOf("cancel") < 0
                      ? '<span title="booking status:' +
                      row.status +
                      '" class="label label-primary"><i class="material-icons">flash_on</i></span>'
                      : ' <span title="booking is canceled" class="label label-warning"><i class="material-icons">block</i></span>';
              out += "</div>";
            }
            return out;
          },
        },

        {
          viewnModes: ['filebookings' + (vm.$userProfile.settings?.HandleEmails == '1' ? '' : 'disabled'), 'places' + (vm.$userProfile.settings?.HandleEmails == '1' ? '' : 'disabled')],
          prop: "successLevel",
          width: "",
          label: "Email",
          clickable: true,
          formatter: function (val, cols, row) {
            // _log_('succesStatusIcons',val,row)
            const m = succesStatusIcons[row.successStatus] || badStatus
            let tt = [row.successStatus, row.emailStatus]
            tt = tt.filter(t => !!t).join(' / ')

            return `<span class="normal material-icons" title="${tt}">${m}</span>`;
          },
        },
        {
          viewnModes: ['filebookings', 'excrs', 'transfers'],
          prop: "customer", minWidth: "150px", label: "Customer Name",
          editable: currentViewMode == "filebookings",
          formatter: function (val, cols, row) {
            if (!val) return '!!! no customer !!!'
            return '<span title="' + row.customer_id + '">' + val + '</span>'
          }
        },
        {
          prop: "loc_code", minWidth: "80px", label: "Resort",
          viewnModes: ['filebookings', 'places',
            'excrs',
            'transfers'],
        },
        {
          viewnModes: ['filebookings', 'places',
            'excrs',
            'transfers'],
          prop: "ppid",
          minWidth: "250px",
          label: "Place",
          isClickable: currentViewMode == "filebookings" || currentViewMode == "places",

          enableClickCell(row) {
            return vm.workingTripType == "EXCRS" || !row.ppid;
          },
          editWhen(row) {
            // _log_(' editWhen(row)', row)
            return (currentViewMode == "filebookings" || currentViewMode == "places") && row.ppid
          },
          editable: currentViewMode == "filebookings" || currentViewMode == "places",
          editorcomponent: {
            is: "s-remote-select",
            queryProp: "q",
            classModel: "pup",
            labelProp: "name",
            valueProp: "id",
            editOptionComponentIs: "s-pupresolver",
            buttonsLeft: true,
            captionField: "typename",
            prefixField: "loc_name",
          },
          formatter: function (val, cols, row) {
            // _log_(">possible_pp>>>" + val, row);
            if (!row.ppid) {
              if (row.possible_pp)
                return (
                    "!!!" +
                    row.possible_pp.ppname +
                    (row.possible_pp.resort
                        ? "(" + row.possible_pp.resort + ")"
                        : "")
                );
              else return "!!!no pickup set";
            }
            if (currentViewMode == 'filebookings' || currentViewMode == 'places')
              return (
                  row.pp_name + " : <small>" + row.loc_name + "</small>"
              );
            // _log_(">>>>" + val, row);
            if (row.meetingName && !row.pp_name) return row.meetingName
            return (
                row.pp_name + (row.meetingName ? "(" + row.meetingName + ")" : "")
            );
          },
        },

        {
          prop: "distributor",
          label: "SRC",
          formatter: function (val, cols, row) {
            let out = row.toc_coname
                ? '<span title="booking is valide" class="label label-primary">' +
                row.toc_coname +
                "</span>"
                : "";

            if (kindOfTrips == "excrs") {
              out += row.rep_name ? row.rep_name : "";
            } else {
              out += row.distributor ? row.distributor : "";
            }
            return out;
          },
        },
        {viewnModes: ['excrs'], prop: "ticketNum", width: "", label: "Ticket"},
        {
          viewnModes: ['excrs'], displayConstrain: 'showtrip',
          label: "Trip",
          minWidth: "100px",
          prop: "tserv_title",
        },
        {
          viewnModes: ['excrs'], displayConstrain: 'showtrip',
          prop: "tripDateTime",
          label: "Date",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatDate(val);
          },
        },
        {
          viewnModes: ['filebookings',
            'transfers'],
          prop: "reference",
          width: "",
          isClickable: currentViewMode == "filebookings",
          label: "Ref/Tn",
          formatter(val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return val || row.ticketNum
          },
        },
        // {prop: "routeNum", width: "", label: "routeNum."},
        // {prop: "routeSeq", width: "", label: "routeSeq."},
        {
          viewnModes: ['filebookings', 'places',
            'transfers'],
          prop: "tripDateTime",
          label: "Date",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatDate(val);
          },
        },
        {
          viewnModes: ['filebookings', 'places',
            'transfers'],
          prop: "tripTitle",
          width: '110px',
          label: '<i class="material-icons">last_page</i>',

          formatter(val, cols, dataContext) {
            //return;
            let rtn = dataContext.tripTitle || '';
            val = val || ''
            // _log_('???', val, dataContext)
            if (dataContext != undefined) {
              let date = new Date(dataContext.tripDateTime * 1000),
                  hours = date.getHours(),
                  minutes = "0" + date.getMinutes(),
                  tripTime = hours + ":" + minutes.substr(-2);
              // if (dataContext.selected) selectedClass = "moving";
              if (dataContext.tripType == "DEP") {
                rtn +=
                    '<i class="label label-warning smicon material-icons">flight_takeoff</i>' +
                    tripTime;
                // rtn.addClasses = "label label-warning " + selectedClass;
              } else if (dataContext.tripType == "ARV") {
                rtn +=
                    '<i class="label label-success smicon material-icons">flight_land</i>' +
                    tripTime;
                // rtn.addClasses = "label label-success " + selectedClass;
              } else if (dataContext.tripType == "EXCRS") {
                rtn +=
                    '<i class="label label-success smicon material-icons">rowing</i>' +
                    tripTime;
                // rtn.addClasses = "label label-success " + selectedClass;
              } else rtn += '<i class="material-icons">location_city</i>';
              if (dataContext.status == "normal")
                rtn = '<i class="material-icons smicon">check</i>' + rtn;
            }
            //        rtn += ' ' + dataContext.humanDate;
            return rtn;
          },
        },

        {
          viewnModes: ['filebookings', 'places',
            'transfers'], prop: "mean", label: "IS"
        },
        {
          viewnModes: ['excrs'],
          prop: "bookedTimeMM",
          label: "PP Time",

        },

        {
          viewnModes: ['excrs',
            'transfers'],
          // isClickable: false,
          prop: "bookedPrice",
          editorcomponent: {
            is: "s-number",
          },
          width: "120px",
          editable: false,
          label: "Cost",
          formatter(val, colDefs, row) {
            return vm.$theMoney(val) + "&euro;";
          },
        },
        {
          viewnModes: ['filebookings', 'places',
            'transfers'],
          prop: "finalPickupTime",
          label: "Trans. Time",
          isClickable: this.workingTripType == "EXCRS",
          enableClickCell(row) {
            return row.mean != "transfer" || !row.mean;
          },
          editable: this.workingTripType != "EXCRS",
          editWhen(row) {
            return row.mean || row.mean == "transfer";
          },
          editorcomponent: {
            is: "s-time",
          },

        },

        {
          viewnModes: ['places', 'filebookings'],
          prop: "adults",
          width: "100px",
          label: "Adlt",
          editable: true
        },
        {
          viewnModes: ['places', 'filebookings'],
          prop: "children",
          width: "100px",
          label: "Kids",
          editable: true
        },
        {viewnModes: ['filebookings',], prop: "ages", label: "Birth Dates"},
        {
          // viewnModes: ['filebookings',
          //              'transfers'],
          prop: "pax",
          width: "100px",
          label: "Px(A/K/F)",
          formatter: function (val, cols, row) {
            if (!row.adults && !row.children && !row.freePersons) return;
            // _log_(">>>>" + val, row);
            return (
                ((row.adults * 1 || 0) +
                    +
                        (row.children * 1 || 0) +
                    +
                        (row.freePersons * 1 || 0)) +
                "(" +
                (row.adults || 0) +
                "/" +
                (row.children || 0) +
                "/" +
                (row.freePersons || 0) +
                ")"
            );
          },
        },
        {
          viewnModes: ['places', 'filebookings',
            'transfers'],
          prop: "meantype",
          width: "80px",
          label: '<i class="material-icons">directions</i>',
          editable: true,
          editorcomponent: {
            is: "s-general-select",
            fit: true,
            options: ['shuttle',
              'private',
              'private minibus',
              'direct',
              'notransfer'],

            simpleOptions: true

            // multiple: true
          },
          formatter: function (val, cols, row) {
            var displayVal = val,
                value = val;
            // return '<div class="option">' + displayVal + "</div>";
            if (val == 'normal' || val == 'shuttle' || !val)
              displayVal =
                  '<i class="material-icons" title="common shuttle">airport_shuttle</i>';
            if (value == "private")
              displayVal =
                  '<i class="material-icons" title="private car">directions_car</i>';
            if (value == "private minibus")
              displayVal =
                  '<i class="material-icons"  title="private shuttle">directions_bus</i>';
            if (value == "direct")
              displayVal =
                  '<i class="material-icons" title="direct transfer">arrow_forward</i>';
            if (value == "notransfer")
              displayVal =
                  '<i class="material-icons" title="no transfer">directions_walk</i>';
            return '<div class="option">' + displayVal + "</div>";
          },
        },


        {
          viewnModes: ['filebookings',
            'transfers'],
          label: "Transfer Comment",
          minWidth: "150px",

          prop: "transfercomment",
        },
        {
          viewnModes: ['filebookings' + (!this.$route.params.fileid || this.$route.params.fileid == 'all' ? '' : '_disabled')],
          prop: "file", minWidth: "100px", label: "File",
          isClickable: true,
          formatter: function (val, cols, row) {
            if (!val) return '!!!orphan !!!'
            return '<span title="' + val.id + '">' + val.name + '</span>'
          }
        },

      ];


      //     this.$route.query

      return cols.filter(lecol => (!lecol.viewnModes || lecol.viewnModes.indexOf(currentViewMode) >= 0) && (!lecol.displayConstrain || lecol.displayConstrain == extraConstrain));
    },
    datepickerOptions() {
      return {
        disabledDate: this.isBookable,
      };
    },
  },
};
</script>
<style>
div.status-cell span.label {
  padding: 4px !important;
  border-radius: 3px;
  margin-left: 1px;
  line-height: 20px;
  height: 20px;
}

div.status-cell span.label i.material-icons {
  font-size: 18px !important;
}
</style>
